import { render, staticRenderFns } from "./bascInfo.vue?vue&type=template&id=5b934968&scoped=true&"
import script from "./bascInfo.vue?vue&type=script&lang=js&"
export * from "./bascInfo.vue?vue&type=script&lang=js&"
import style0 from "./bascInfo.vue?vue&type=style&index=0&id=5b934968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b934968",
  null
  
)

export default component.exports